import {useContext, useRef, useState} from "react";
import Footer from "../../Shared/Components/Footer";
import ThemeContext from "../../Shared/Theme/ThemeContext";
import Keyboard from "react-simple-keyboard";
import KeyboardLayout from "../../Shared/Theme/KeyboardLayout";
import "react-simple-keyboard/build/css/index.css";
import Score, {ScoreData} from "../../Shared/Components/Score";
import {GameHint} from "../../Quiz/Components/GameHint";

interface GameFinishProps {
    title: string
    hint: string | false
    score: ScoreData
    scoreBackground?: string
    pageTitleElement?: JSX.Element,
    onCancel: () => void
    onEnterName : (name : string) => void;
}

export interface KeyboardState {
    layoutName: string,
    input: string,
}

export function GameFinish(props: GameFinishProps) {

    const [name, setName] = useState("")
    const theme = useContext(ThemeContext)
    const keyboard = useRef(null);

    const [state, setState] = useState<KeyboardState>({
        layoutName: "shift",
        input: ""
    })

    const onChange = (input) => {
        setName(input)
        setState({ input: input as string, layoutName: state.layoutName} as KeyboardState);
    }

    const onKeyPress = button => {
        if (button === "{shift}" || button === "{lock}") handleShift()
    }

    const handleShift = () => {
        const layoutName = state.layoutName
        setState({
            input: state.input,
            layoutName: layoutName === "default" ? "shift" : "default"
        } as KeyboardState)
    }

    const onChangeInput = event => {
        const input = event.target.value
        const layoutName = state.layoutName
        setName(input)
        setState({ input: input, layoutName: layoutName } as KeyboardState)
        keyboard.current.setInput(input)
    }

    return <div className="game-finished" style={{backgroundImage:'url('+theme.backgroundImage+')'}}>
        { props.pageTitleElement ? props.pageTitleElement : <h1>{props.title}</h1> }
        { props.hint && <GameHint text={props.hint}/> }
        <div className="wrapper">
            <div className="enter-name">
                <img className="logo" src="images/shared/footer-logo.png" alt="logo" />
                <div>
                    <p className="title">Dyplom</p>
                    <input placeholder="Wpisz swoje imię" value={state.input} onChange={onChangeInput} /><br />
                    <div className="keyboard-container" style={!theme.tableVersion ? { "display": "none" }: {}}>
                        <Keyboard
                            keyboardRef={r => (keyboard.current = r)}
                            layoutName={state.layoutName}
                            layout={KeyboardLayout.layout}
                            onChange={onChange}
                            onKeyPress={onKeyPress}
                        />
                    </div>
                    <button className="btn" onClick={() => name !== "" && props.onEnterName(name)}>Zobacz dyplom</button>
                </div>
            </div>
        </div>
        <Score data={props.score} backgroundImage={props.scoreBackground}/>
        <Footer home={props.onCancel}/>
    </div>
}